import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck } from 'lucide-react';
export function Revelation() {
  return <section className="py-24 bg-forest text-cream relative overflow-hidden" data-id="element-158">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-5" data-id="element-159">
        <div className="absolute top-0 left-0 w-full h-full" style={{
        backgroundImage: 'radial-gradient(#d4a24a 1px, transparent 1px)',
        backgroundSize: '32px 32px'
      }} data-id="element-160"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-forest-light border border-gold/30 p-8 md:p-12 rounded-3xl shadow-2xl text-center" data-id="element-162">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gold rounded-full mb-6 shadow-gold-glow" data-id="element-163">
            <Zap className="w-8 h-8 text-forest-dark" data-id="element-164" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-165">
            Aquí está el secreto que los grandes seguros médicos no te dicen:
          </h2>

          <p className="text-xl md:text-2xl mb-8 text-cream-light font-medium" data-id="element-166">
            Puedes "hackear" el impacto del azúcar en tu sangre con trucos de 10
            segundos. No es magia, es{' '}
            <span className="text-gold font-bold" data-id="element-167">Biohacking Nutricional</span>.
          </p>

          <div className="bg-forest-dark/50 p-6 rounded-xl text-left mb-8" data-id="element-168">
            <p className="text-lg text-cream-dark leading-relaxed" data-id="element-169">
              Imagina ponerle un "freno de mano" a la glucosa antes de comerte
              un plato de pozole. Al usar el{' '}
              <strong className="text-gold" data-id="element-170">Código Metabólico Latino</strong>,
              aprendes a crear un escudo en tu estómago que atrapa el azúcar y
              la convierte en energía estable, en lugar de grasa abdominal y
              enfermedad.
            </p>
          </div>

          <div className="flex items-center justify-center text-cream-light font-medium" data-id="element-171">
            <ShieldCheck className="w-6 h-6 text-gold mr-2" data-id="element-172" />
            <span data-id="element-173">Ciencia comprobada, adaptada a nuestra cultura.</span>
          </div>
        </motion.div>
      </div>
    </section>;
}